import { Box, Text, VStack, HStack, Badge } from '@chakra-ui/react'
import { User, FileText } from 'lucide-react'
import type { CoOwnerFolderLink } from '../hooks/useCoOwnerFolders'

interface CoOwnerFolderCardProps {
  coOwnerLink: CoOwnerFolderLink
  documentCount?: number
  onClick: () => void
}

export function CoOwnerFolderCard({
  coOwnerLink,
  documentCount = 0,
  onClick,
}: CoOwnerFolderCardProps) {
  const isInactive = !coOwnerLink.is_active

  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      p={5}
      bg="white"
      cursor="pointer"
      transition="all 0.2s"
      opacity={isInactive ? 0.5 : 1}
      _hover={{
        borderColor: isInactive ? 'gray.300' : 'brand.500',
        boxShadow: 'md',
        transform: 'translateY(-2px)',
      }}
      onClick={onClick}
    >
      <VStack align="stretch" gap={3}>
        <HStack gap={3}>
          <Box
            p={2}
            borderRadius="md"
            bg={isInactive ? 'gray.50' : 'blue.50'}
            borderWidth="1px"
            borderColor={isInactive ? 'gray.200' : 'blue.200'}
          >
            <User size={20} color={isInactive ? '#718096' : '#3182CE'} />
          </Box>

          <VStack align="start" gap={0} flex={1} minW={0}>
            <HStack gap={2}>
              <Text
                fontSize="sm"
                fontWeight="semibold"
                color={isInactive ? 'gray.500' : 'gray.800'}
                lineClamp={2}
                wordBreak="break-word"
              >
                {coOwnerLink.folder_name}
              </Text>
              {isInactive && (
                <Badge colorPalette="gray" size="sm">
                  Ancien
                </Badge>
              )}
            </HStack>

            {documentCount > 0 && (
              <HStack gap={1} fontSize="xs" color={isInactive ? 'gray.400' : 'gray.600'} mt={1}>
                <FileText size={12} />
                <Text>
                  {documentCount} doc{documentCount !== 1 ? 's' : ''}
                </Text>
              </HStack>
            )}
          </VStack>
        </HStack>
      </VStack>
    </Box>
  )
}
